<template lang="html">

  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">Catálogos</li>
      </ol>
    </nav>

    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12 col-md-6 col-lg-3">
          <vx-card class="text-center investorsPrograms">
            <vs-button @click="$router.push('/catalogs/fg_survey')" type="line" size="large">Encuesta de Grupos <br/> de Familia Preguntas-Respuestas</vs-button>
          </vx-card>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-3">
          <vx-card class="text-center feedback">
            <vs-button @click="$router.push('/catalogs/project_events')" type="line" size="large">Eventos de Proyecto</vs-button>
          </vx-card>
        </div>
        <!-- <div class="col-sm-12 col-md-6 col-lg-3">
          <vx-card class="text-center feedback">
            <vs-button @click="$router.push('/catalogs/family_groups')" type="line" size="large">Grupos de Familia</vs-button>
          </vx-card>
        </div> -->
        <div class="col-sm-12 col-md-6 col-lg-3">
          <vx-card class="text-center feedback">
            <vs-button @click="$router.push('/catalogs/product_groups')" type="line" size="large">Grupos de Productos</vs-button>
          </vx-card>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-3">
          <vx-card class="text-center investorsPrograms">
            <vs-button @click="$router.push('/catalogs/fg_reqs')" type="line" size="large">Requerimientos <br/> de Grupos de Familia</vs-button>
          </vx-card>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-3">
          <vx-card class="text-center feedback">
            <vs-button @click="$router.push('/catalogs/cashing_events')" type="line" size="large">Eventos de Cobranza</vs-button>
          </vx-card>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-3">
          <vx-card class="text-center feedback">
            <vs-button @click="$router.push('/catalogs/sections')" type="line" size="large">Secciones-Campos</vs-button>
          </vx-card>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-3">
          <vx-card class="text-center feedback">
            <vs-button @click="$router.push('/catalogs/default_parameters')" type="line" size="large">Default Parameters</vs-button>
          </vx-card>
        </div>
      </div>
    </div>
  </div>

</template>

<script lang="js">
  export default  {
    name: 'catalogs',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
}
</script>

<style scoped>
  .vx-card {
    cursor: pointer !important;
    margin-bottom: 1rem !important;
    min-height: 8rem !important;
  }
  .investorsPrograms button {
    padding: 5.5px !important;
  }
  .feedback button {
    padding: 14px !important;
    padding-left: 5px !important;
    padding-top: 1.5rem !important;
  }
</style>
